import commonTranslations from 'shared/translations/overlay-common-translations';
import renderVideoSignInToWatchButtonText, {
  isVisible as isVideoSignInToWatchButtonVisible,
} from '../video/sign-in-to-watch-button-text';


/**
 * Is video sign in to play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export const isVisible = isVideoSignInToWatchButtonVisible;

/**
 * Video sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.startWatching
 * @return {React.Component}
 */
export default function renderSignInToWatchButtonText(props) {
  props.translation = props.translation || commonTranslations.startWatching;
  return renderVideoSignInToWatchButtonText(props);
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/channel/sign-in-to-watch-button-text.js